/** Staleness rules for the admin Backups card. Nightly jobs: 26 h; the weekly reconcile: 8 days. */
const HOUR = 3600_000;

export function backupStaleLimitMs(job: string): number {
  return job === "centcom-reconcile" ? 8 * 24 * HOUR : 26 * HOUR;
}

export function backupStaleness(job: string, finishedAt: string | Date | null | undefined, now: Date = new Date()): {
  stale: boolean;
  ageMs: number | null;
} {
  if (!finishedAt) return { stale: true, ageMs: null };
  const t = new Date(finishedAt).getTime();
  if (Number.isNaN(t)) return { stale: true, ageMs: null };
  const ageMs = Math.max(0, now.getTime() - t);
  return { stale: ageMs > backupStaleLimitMs(job), ageMs };
}

export function formatAge(ageMs: number | null): string {
  if (ageMs === null) return "never";
  const h = ageMs / HOUR;
  if (h < 1) return `${Math.max(1, Math.round(ageMs / 60000))} min ago`;
  if (h < 48) return `${Math.round(h)} h ago`;
  return `${Math.round(h / 24)} d ago`;
}
